<script setup lang="ts">
const props = defineProps<{
  resourceId?: number
  resourceType?: ResourceType
}>()

const { data: userInfo } = useAuth()
const $toast = useToast()
const emit = defineEmits(['success', 'cancel'])

const selected = ref<number[]>([])
const oldChecked = ref<number[]>([])

const { data: collectionList, refresh } = useAsyncData(
  `userCollection:${userInfo.value.user.id}`,
  () => fetchCollectionList(userInfo.value.user.id),
  {
    default: () => [] as Collection[]
  }
)

const { data: alreadyFavList, refresh: refreshFav } = useAsyncData(
  `userFav:${userInfo.value.user.id}:${props.resourceId}:${props.resourceType}`,
  async () => {
    const res = await fetchCollectionByRes(
      userInfo.value.user.id,
      props.resourceId,
      props.resourceType
    )
    selected.value = res.map((item) => item.id)
    oldChecked.value = res.map((item) => item.id)
  },
  {
    default: () => [] as PostFavoriteFolder[]
  }
)

const statusMap: Record<number, string> = {
  1: '公开',
  2: '私密',
  3: '隐藏'
}

watch(props, () => {
  selected.value = []
  refresh()
  refreshFav()
})

function cancel() {
  emit('cancel')
}

async function addToFavorite(listId: number) {
  return requestAddResToCollection(
    props.resourceId!,
    props.resourceType!,
    listId
  )
}

async function removeFromFavorite(listId: number) {
  return requestCancelFavByRes(props.resourceId!, props.resourceType!, listId)
}

async function submit() {
  const addList = selected.value.filter(
    (item) => !oldChecked.value.includes(item)
  )
  const removeList = oldChecked.value.filter(
    (item) => !selected.value.includes(item)
  )
  await Promise.all([
    Promise.all(addList.map((item) => addToFavorite(item))),
    Promise.all(removeList.map((item) => removeFromFavorite(item)))
  ])
  await refreshFav()
  if (selected.value.length > 0) {
    $toast.success('收藏成功')
  } else {
    $toast.success('已取消收藏')
  }
  emit('success')
  useEmitter().emit('favoriteSuccess', {
    resourceId: props.resourceId!,
    resourceType: props.resourceType!,
    isFavorite: selected.value.length > 0
  })
}
</script>

<template>
  <div class="m-favorite-form">
    <div class="m-favorite-form__header">收藏</div>
    <div class="m-favorite-form__body">
      <n-checkbox-group v-model:value="selected" class="m-collection-list">
        <n-checkbox
          v-for="c in collectionList"
          :key="c.id"
          :value="c.id"
          class="m-collection-list-item"
          size="large"
        >
          <span class="m-collection-list-item__name">
            {{ c.name }}
          </span>
          <span class="m-collection-list-item__status">
            [{{ statusMap[c.status] }}]
          </span>
        </n-checkbox>
      </n-checkbox-group>
    </div>
    <div class="m-favorite-form__footer"></div>

    <n-button
      type="primary"
      block
      strong
      class="m-favorite-form__button"
      @click="submit"
    >
      提交
    </n-button>
    <n-button block strong class="m-favorite-form__button" @click="cancel">
      取消
    </n-button>
  </div>
</template>

<style lang="scss" scoped>
.m-favorite-form {
  width: 100%;
  padding: 0 24px;
  background-color: #fff;
  border-radius: 8px;

  &__header {
    display: flex;
    pointer-events: none;
    font-size: 18px;
    margin-bottom: 12px;
  }
  &__body {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 12px;
  }
  &__footer {
    display: flex;
    justify-content: center;
    color: #999;
    font-size: 14px;
    margin-bottom: 12px;
  }
  &__button {
    margin-top: 12px;
  }
  .m-collection-list {
    width: 100%;
    display: flex;
    flex-direction: column;
    &-item {
      width: 100%;
      margin: 8px 0;
      :deep(.n-checkbox__label) {
        width: 100%;
        display: flex;
        justify-content: space-between;
      }
      &__name {
        width: 0;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      &__status {
        margin-left: 4px;
        color: var(--color-gray-400);
      }
    }
  }
}
</style>
